import { render, staticRenderFns } from "./bulletin.vue?vue&type=template&id=f775ccbc&scoped=true&v-once=true"
import script from "./bulletin.vue?vue&type=script&lang=js"
export * from "./bulletin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f775ccbc",
  null
  
)

export default component.exports